import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useCidco } from "./CidcoLayout";
import FacilitiesGrid from "@/components/FacilitiesGrid";

export default function Facilities() {
  const data = useCidco();
  const items = data?.facilities || [];
  return (
    <div data-testid="cid-facilities">
      <PageHero eyebrow="Campus" title="World-class Facilities" accent="cyan" />
      <PageBody>
        <FacilitiesGrid
          items={items}
          testidPrefix="cid-facilities"
          accentChipClass="bg-cyan-500/10 text-cyan-700 ring-1 ring-cyan-500/20"
        />
      </PageBody>
    </div>
  );
}
